import { render, staticRenderFns } from "./undelivered.vue?vue&type=template&id=9c7528a2&scoped=true&"
import script from "./undelivered.vue?vue&type=script&lang=js&"
export * from "./undelivered.vue?vue&type=script&lang=js&"
import style0 from "./undelivered.vue?vue&type=style&index=0&id=9c7528a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7528a2",
  null
  
)

export default component.exports